import { EquityEntity } from '@genial/services';
import { Utils } from '@genial/utils';

type EquityTableKey =
  | 'productName'
  | 'lastPrice'
  | 'bidPrice'
  | 'closePrice'
  | 'askPrice'
  | 'amountOrder'
  | 'price'
  | 'totalPrice'
  | 'buttonSelectProduct';

export interface EquityTableProps {
  OffersAll?: Offer[];
  OffersSearchTerm?: Offer[];
  isLoading: boolean;
  isLoadingMore: boolean;
  handleEndReached: () => void;
  invalidColumns?: boolean;
  hasEmpty: boolean;
}

export const widthCols: Record<EquityTableKey, number> = {
  productName: 14,
  lastPrice: 10,
  bidPrice: 10,
  closePrice: 9,
  askPrice: 10,
  amountOrder: 12,
  price: 15,
  totalPrice: 10,
  buttonSelectProduct: 10,
};

export const invalidColumnsCalc =
  Object.entries(widthCols).reduce((acc, item) => acc + item[1], 0) !== 100;

export const selectedKeysOrderBy = ['productName', 'lastPrice', 'bidPrice', 'closePrice'];

export const tableHead: EquityTableItemProps = {
  productName: 'Produto',
  lastPrice: 'Último preço',
  bidPrice: 'Melhor Compra',
  askPrice: 'Melhor Venda',
  closePrice: 'Fechamento',
  amountOrder: 'Quantidade',
  price: 'Preço por ativo',
  totalPrice: 'Total estimado',
  buttonSelectProduct: '',
};

export type EquityTableItemProps = Record<EquityTableKey, string | null> &
  Partial<{ symbol: string; image: string; priceChangeTax: string; tradeDate: string }>;

export type Offer = EquityEntity & { availableAmount?: number };

export const tableParse = (item: Offer): Partial<EquityTableItemProps> => {
  return {
    productName: item.quote.productName,
    symbol: item.quote.symbol || '',
    image: item.quote.icons.light || '',
    lastPrice: Utils.Mask.Money(item.quote.lastPrice),
    priceChangeTax: Utils.Mask.Percentage(item.quote.priceChangeTax),
    tradeDate: `Atualizado às ${Utils.Mask.DateFormat(item.quote.tradeDate, 'HH:mm')}`,
    askPrice: Utils.Mask.Money(item.quote.askPrice),
    closePrice: Utils.Mask.Money(item.quote.closePrice),
    bidPrice: Utils.Mask.Money(item.quote.bidPrice),
    price: Utils.Mask.Money(item.quote.lastPrice),
    buttonSelectProduct: 'Selecionar',
  };
};

export const messageError = '--';

export interface EquityTableItemListProps {
  data?: EquityEntity[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  hasEmpty?: boolean;
  handleEndReached: () => void;
}

export type EquityOperationType = 'buy' | 'sale';
export type DirectTreasuryOperationType = 'apply' | 'rescue';
